export default {
    namespaced: true,

    state:{
        notificationQueue: [], // {message: String, confirm?: Boolean, type?: String}
    },
    getters:{
        haveNotification:(s)=>{
            return !!s.notificationQueue.length;
        }
    },
    mutations:{
        putNotification: (s, notification)=>{
            s.notificationQueue.push(notification);
        },
        putNotificationDefault: (s, message)=>{
            s.notificationQueue.push({message, type: 'default'});
        },
        putNotificationWarn: (s, message)=>{
            s.notificationQueue.push({message, type: 'warn'});
        },
        putNotificationErr: (s, message)=>{
            s.notificationQueue.push({message, type: 'error'});
        },
    },
    actions: {
        pullNotification:({state})=>{
            return state.notificationQueue.shift();
        },
    },
}